import React from "react";
import { observer, inject } from "mobx-react";
import Page from "./Components/Page";
import { generateUrl } from "Services/withDefaultParams";
import routes from "Configs/routes";

@inject("ApplicationModel")
@observer
export default class Catalog extends React.Component {
	onOperatorSelect(provider) {
		this.props.history.push({
			pathname: generateUrl(routes.OperatorDetails.route, {
				operator: provider.url_name,
				regionUrl: provider.region.url,
			}),
		});
	}

	onOperatorConnect(provider) {
		this.props.history.push({
			pathname: generateUrl(routes.OperatorDetails.route, {
				operator: provider.url_name,
				regionUrl: provider.region.url,
			}),
		});
	}

	onOperatorReviews(provider) {}

	render() {
		return (
			<Page
				onOperatorSelect={(provider) => this.onOperatorSelect(provider)}
				onOperatorConnect={(provider) => this.onOperatorConnect(provider)}
				onOperatorReviews={(provider) => this.onOperatorReviews(provider)}
			/>
		);
	}
}
